const Tag = {
  //#region Sleep
  sleep: function (seconds = 0) {
    /**
     * Função que retorna uma Promise que resolve após um determinado tempo em segundos
     * @param {number} seconds - Tempo em segundos
     * */

    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
  },

  //--------------------------------------------------------------------------------

  //#region SetColorValueName
  setColorValueName: function (backgroundColor) {
    /**
     * Função que cria um container com a cor de fundo
     * @param {string} backgroundColor - Cor de fundo
     * */

    // Cria um novo elemento div para o container de valor de cor
    const colorValueName = document.createElement('div');

    // Adiciona classes CSS ao container para estilização
    colorValueName.classList.add(
      'color-value-name',
      'component-products-filter-rounded-full',
      'component-products-filter-border',
      'component-products-filter-border-gray-300',
      'component-products-filter-mr-2',
      'component-products-filter-h-4',
      'component-products-filter-w-4'
    );

    // Verifica se a cor de fundo é um gradiente
    if (backgroundColor.includes('/')) {
      let firstColor = backgroundColor.split('/')[0];
      let secondColor = backgroundColor.split('/')[1];

      // Define a cor de fundo do container
      colorValueName.style.backgroundImage = `linear-gradient(135deg, ${firstColor} 50%, ${secondColor} 51%)`;
    } else {
      // Define a cor de fundo do container
      colorValueName.style.backgroundColor = backgroundColor;
    }

    // Retorna o container criado
    return colorValueName;
  },

  //--------------------------------------------------------------------------------
  //#region HandleNumberOfProducts
  handleNumberOfProducts: () => {
    /**
     * Função que altera o número de produtos exibidos
     */

    if (window.innerWidth < 993) {
      return;
    }

    //--------------------------------------------------------------------------------

    // Seleciona o container de produtos e o container de botões de layout
    const listProducts = document.querySelector(`.list-products`);
    const formLayoutSelector = document.querySelector(`.form-layout-selector`);

    // Verifica se o container de produtos existe,
    // Se existir armazena os botões de layout em um array
    if (formLayoutSelector) {
      const layoutButtonsArray = Array.from(document.querySelectorAll(`[button-layout]`));

      // Verifica se o array de botões de layout possui algum botão
      if (layoutButtonsArray.length > 0) {
        // Adiciona evento de click para cada botão de layout
        layoutButtonsArray.forEach((button) => {
          button.addEventListener(`click`, () => {
            if (button.classList.contains(`selected`)) {
              // Se o botão clicado já estiver selecionado, não faz nada
              return;
            } else {
              // Remove a classe selected de todos os botões e adiciona a classe selected no botão clicado
              layoutButtonsArray.forEach((b) => {
                b.classList.remove(`selected`);
              });
              button.classList.add(`selected`);
            }

            let newLayout = button.getAttribute(`layout-columns`);

            Tag.sleep(0.5)
              .then(() => {
                listProducts.style.opacity = `0`;
                // Altera o cursor do mouse para espera
                document.body.style.cursor = `wait`;
              })
              .then(() => {
                Tag.sleep(0.5).then(() => {
                  listProducts.setAttribute(`layout-columns`, newLayout);
                });
              })
              .then(() => {
                Tag.sleep(0.5).then(() => {
                  listProducts.style.opacity = `1`;
                  // Altera o cursor do mouse para espera
                  document.body.style.cursor = `default`;
                });
              });
          });
        });
      }
    }
  },

  //--------------------------------------------------------------------------------

  //#region HandleColorFilter
  handleColorFilter: () => {
    /**
     * Função que adiciona a cor de fundo no container de valores de cor
     * */

    // Obtendo as cores do arquivo Californio.colors.js
    const colors = window.Californio.colors;

    // Busca as cores armazenadas no objeto window.Californio
    const filterColorsSet = window.Californio.filterColorsSet;

    // Verifica se as cores já foram carregadas
    if (filterColorsSet) return;

    // Verifica se o array de cores existe
    if (!colors) return;

    // Seleciona todos os containers de valores de cor
    const colorValueContainers = Array.from(document.querySelectorAll(`.color-value-container`));

    // Verifica se existem containers de valores de cor
    if (colorValueContainers.length > 0) {
      colorValueContainers.forEach((colorValueContainer) => {
        // Obtém o texto do container de valor de cor
        const colorValueText = colorValueContainer.querySelector('.color-value-text').innerText;

        // Verifica se o texto do container de valor de cor existe
        if (!colorValueText) return;

        // Itera sobre o array de cores para encontrar a cor correspondente
        for (let color of colors) {
          const [colorName, colorHex] = color.split(' | ');

          // Verifica se o nome da cor corresponde ao texto do container de valor de cor
          if (colorName.toLowerCase() === colorValueText.toLowerCase()) {
            // Cria um novo container com a cor de fundo e adiciona ao container de valor de cor
            colorValueContainer.appendChild(Tag.setColorValueName(colorHex));
          }
        }
      });
    }

    // Define que as cores já foram carregadas
    window.Californio.filterColorsSet = true;
  },

  //--------------------------------------------------------------------------------

  //#region ToggleFilterRoot
  toggleFilterRoot: (buttonType, buttonFilter, buttonOrder) => {
    /**
     * Função que exibe/oculta os containers de filtros e ordenação
     * @param {string} buttonType - Tipo do botão clicado
     * @param {HTMLElement} buttonFilter - Botão de filtro
     * @param {HTMLElement} buttonOrder - Botão de ordenação
     */

    // Seleciona a tag de background
    const backgroundTag = document.querySelector(`.background-tag-opaque`);

    // Seleciona os containers de filtros e ordenação
    const filterRoot = document.querySelector(`#component-products-filter-root`);
    const orderBlock = document.querySelector(`.vnda-products-filter-horizontal-sort-container`);
    const filterPriceBlock = document.querySelector(`.vnda-products-filter-price-filter-container`);
    const filterTagsBlocks = document.querySelectorAll(`.vnda-products-filter-horizontal-tags-container`);
    const filterPropsBlocks = document.querySelectorAll(`.vnda-products-filter-horizontal-properties-container`);
    const containerFilterHorizontal = document.querySelector(`.vnda-products-filter-horizontal`);

    function showBackground() {
      /**
       * Função que exibe o background
       */

      backgroundTag.classList.add(`visible`);
    }
    function hideBackground() {
      /**
       * Função que oculta o background
       */

      backgroundTag.classList.remove(`visible`);
    }

    function hiddenSort() {
      /**
       * Função que oculta o container de ordenação
       */
      // Alterando o overflow e a altura do container de filtros para 0px
      filterRoot.style.overflow = `hidden`;
      filterRoot.style.height = `0px`;

      orderBlock && orderBlock.classList.remove('-visible');
      buttonOrder && buttonOrder.classList.add(`closed`);
    }
    function showSort() {
      /**
       * Função que exibe o container de ordenação
       */
      orderBlock && orderBlock.classList.add('-visible');
      buttonOrder && buttonOrder.classList.remove(`closed`);

      // Aplicando a altura do container de filtros no container de ordenação e habilitando o overflow
      filterRoot.style.overflow = `initial`;
      filterRoot.style.height = `calc(${containerFilterHorizontal.getBoundingClientRect().height}px + 1.714rem)`;
    }

    function hiddenFilters() {
      /**
       * Função que oculta o container de filtros
       */

      // Alterando o overflow e a altura do container de filtros para 0px
      filterRoot.style.overflow = `hidden`;
      filterRoot.style.height = `0px`;

      filterPriceBlock && filterPriceBlock.classList.remove('-visible');
      buttonFilter && buttonFilter.classList.add(`closed`);

      if (filterTagsBlocks) {
        filterTagsBlocks.forEach((filterTagsBlock) => {
          filterTagsBlock.classList.remove('-visible');
        });
      }
      if (filterPropsBlocks) {
        filterPropsBlocks.forEach((filterPropsBlock) => {
          filterPropsBlock.classList.remove('-visible');
        });
      }
    }

    function showFilters() {
      /**
       * Função que exibe o container de filtros
       */
      filterPriceBlock && filterPriceBlock.classList.add('-visible');
      buttonFilter && buttonFilter.classList.remove(`closed`);

      if (filterTagsBlocks) {
        filterTagsBlocks.forEach((filterTagsBlock) => {
          filterTagsBlock.classList.add('-visible');
        });
      }
      if (filterPropsBlocks) {
        filterPropsBlocks.forEach((filterPropsBlock) => {
          filterPropsBlock.classList.add('-visible');
        });
      }
      // Aplicando a altura do container de filtros no container de ordenação e habilitando o overflow
      filterRoot.style.overflow = `initial`;
      filterRoot.style.height = `calc(${containerFilterHorizontal.getBoundingClientRect().height}px + 1.714rem)`;
    }

    // A série de verificações abaixo foi criada para cobrir todas as possibilidades de interação com os botões de
    // filtros, de maneira que o usuário possa clicar em qualquer um deles e o container de filtros seja exibido
    // corretamente.

    // Verifica se o container de filtros está visível
    if (!filterRoot) return;

    // Verifica qual botão foi clicado
    if (buttonType == 'order') {
      if (filterRoot.classList.contains('-visible')) {
        if (filterRoot.classList.contains('filter')) {
          // Substitui a classe filter pela classe order
          filterRoot.classList.replace('filter', 'order');
          hiddenFilters();
          showSort();
          // showBackground();
        } else {
          // Remove a classe order e oculta o container
          filterRoot.classList.remove('-visible', 'order');
          hiddenSort();
          // hideBackground();
        }
      } else {
        // Adiciona a classe order e exibe o container
        filterRoot.classList.add('-visible', 'order');
        hiddenFilters();
        showSort();
        // showBackground();
      }
    }

    // Verifica qual botão foi clicado
    if (buttonType == 'filter') {
      if (filterRoot.classList.contains('-visible')) {
        if (filterRoot.classList.contains('order')) {
          // Substitui a classe order pela classe filter
          filterRoot.classList.replace('order', 'filter');
          hiddenSort();
          showFilters();
          // showBackground();
        } else {
          // Remove a classe filter e oculta o container
          filterRoot.classList.remove('-visible', 'filter');
          hiddenFilters();
          // hideBackground();
        }
      } else {
        // Adiciona a classe filter e exibe o container
        filterRoot.classList.add('-visible', 'filter');
        hiddenSort();
        showFilters();
        // showBackground();
      }
    }
  },

  //--------------------------------------------------------------------------------

  //#region HandlerFilter
  // Função para clicar em todos os botões de filtros
  handlerFilter: () => {
    const filterButtons = document.querySelectorAll(`.component-products-filter-ml-auto`);
    const buttons = Array.from(filterButtons);

    // Clica em todos os botões de filtros
    buttons.forEach((button) => {
      button.click();
    });
  },

  //--------------------------------------------------------------------------------

  //#region HandleInfinityScrollButton
  handleInfinityScrollButton: function () {
    /**
     * Função que clica no botão de carregar mais produtos quando o scroll está no final da página
     */

    // Seleciona o contador de produtos
    const totalProducts = document.querySelector('.count-pages .total-products');

    function updateTotalProducts() {
      /**
       * Função que atualiza o total de produtos
       */
      setTimeout(() => {
        totalProducts.innerHTML = document.querySelectorAll('.product-block').length;
      }, 1000);
    }

    // Adiciona um evento de scroll na janela
    window.addEventListener(`scroll`, function () {
      // Seleciona o botão de carregar mais produtos
      let infinityScrollButton = document.querySelector(`.infinity-scroll-button`);

      if (infinityScrollButton) {
        let infinityScrollButtonRect = infinityScrollButton.getBoundingClientRect();
        if (window.scrollY + window.innerHeight >= infinityScrollButtonRect.top) {
          infinityScrollButton.click();
          updateTotalProducts();
        }
      }
    });
  },

  //--------------------------------------------------------------------------------

  //#region ListenerFilter

  listenerFilter: function () {
    /**
     * Função que adiciona um evento de click para os botões de filtro
     */

    const pageTag = document.querySelector(`.page-tag`);

    if (!pageTag) return;

    let containerTagTop = document.querySelector(`.container.tag`).getBoundingClientRect().top - 150;

    const btFilter = document.querySelector(`[button-filter]`);
    const btOrder = document.querySelector(`[button-order]`);
    let btArray = [];
    if (btFilter) btArray.push(btFilter);
    if (btOrder) btArray.push(btOrder);

    if (btArray.length > 0) {
      // Adiciona evento de click para cada botão de filtro
      btArray.forEach((button) => {
        button.addEventListener('click', () => {
          if (window.innerWidth <= 992) {
            window.scrollTo({ top: containerTagTop, behavior: 'smooth' });
          }
          let buttonType = button.getAttribute('data-type-button');
          Tag.toggleFilterRoot(buttonType, btFilter, btOrder);
          Tag.handleColorFilter();
        });
      });
    }
  },
  //--------------------------------------------------------------------------------
  //#region TagDescription
  // Função para expandir descrição da tag
  handlerTagDescription: () => {
    const bannerTopo = document.querySelector(`.banner-topo.-bottom`);

    if (!bannerTopo) return;

    const contentContainer = bannerTopo.querySelector(`.content.container`);

    // Obtém a altura da descrição da tag
    const descriptionHeight = contentContainer.getBoundingClientRect().height;

    // Seleciona o botão e a descrição da tag
    const button = bannerTopo.querySelector(`.button-expand-shrink`);

    // Adiciona evento de click para o botão
    button.addEventListener(`click`, () => {
      // Alterna a classe expanded
      contentContainer.classList.toggle(`expanded`);
      // Altera a altura da descrição da tag
      contentContainer.style.height = contentContainer.classList.contains(`expanded`)
        ? `calc(${descriptionHeight}px + ${descriptionHeight * 0.15}px)`
        : `11rem`;
      // Altera o texto do botão
      button.innerHTML = contentContainer.classList.contains(`expanded`) ? `Mostrar menos` : `Ler mais`;
    });
  },

  handlerProductCount: () => {
    const pageTag = document.querySelector(`.page-tag`);

    if (!pageTag) return;
    // lógica criada para definir a contagem de produtos com o infinitiScroll
    const descriptionCount = document.querySelector('.description-count');
    const productCount = document.getElementById('productCount').value;
    const currentProductCount = document.querySelectorAll('.list-products')[0];
    descriptionCount.innerText = 'Mostrando ' + currentProductCount.childElementCount + ' de ' + productCount;
  },
  //#region Init
  init: function () {
    /**
     * Função que inicializa as funções da página
     */
    const _this = this;

    _this.listenerFilter();

    // _this.handleNumberOfProducts();
    _this.handleInfinityScrollButton();
    // _this.handlerTagDescription();
    // _this.handlerProductCount();
  },
};

export default Tag;
